export default __webpack_public_path__ + "static/plunker-fce3d999f7cb8245fd2a241d6208a69f.svg";